var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5556 4H4.44444C3.2657 4 2.13524 4.5074 1.30175 5.41059C0.468253 6.31377 0 7.53876 0 8.81605V30.4883C0 31.7656 0.468253 32.9906 1.30175 33.8937C2.13524 34.797 3.2657 35.3043 4.44444 35.3043H35.5556C36.7343 35.3043 37.8648 34.797 38.6983 33.8937C39.5317 32.9906 40 31.7656 40 30.4883V8.81605C40 7.53876 39.5317 6.31377 38.6983 5.41059C37.8648 4.5074 36.7343 4 35.5556 4Z",
    fill: "#EEEEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 4H16.6667V16.0402H0V23.2642H16.6667V35.3043H23.3333V23.2642H40V16.0402H23.3333V4Z",
    fill: "#CE1124"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEng);
export default __webpack_public_path__ + "static/media/ENG.ff5b9bb3839a0b8ac9bb047a6267df77.svg";
export { ForwardRef as ReactComponent };